import store from "@/store"
import { FETCH_ACCESS_TOKEN, FETCH_DISTRICTS } from "@/store/storeTypes";

/* use this plugin to retrieve all backend data before app mount */
export default {
  isReady: async () => await Promise.all([
    store.dispatch(FETCH_DISTRICTS),
    store.dispatch(FETCH_ACCESS_TOKEN),
  ])
}